import { Injectable, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAuth } from '../../models/auth';
import { AppDB } from './../database';
import { EventService } from './../events';
import { CacheService } from './../cache';
import { DOMAIN, EVENTS } from '../../constants';
import { isPlatformBrowser } from '@angular/common';
import { APP_INSTANCE_KEY } from '../../constants';
import { User } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private currentUser: any;

  private endpoint = 'auth';

  private authToken: string;

  isLoggedIn: boolean;

  private admin: boolean;
  // tslint:disable:variable-name
  private _domain = DOMAIN.PUBLIC;
  // tslint:enable:variable-name

  private isBrowser: boolean;

  appDomain: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private http: HttpClient,
    private cache: CacheService,
    private events: EventService,
    private db: AppDB) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.events.observeInstance.subscribe(app => {
        if (app && app.auth && app.user) {
          this.authToken = app.auth;
          this.currentUser = app.user;
          this.isLoggedIn = true;
          this.admin = app.admin;
        }
      });
    }
  }

  async authenticated(): Promise<any> {
    if (this.isBrowser) {
      const app: any = await this.db.appInstance.getItem(APP_INSTANCE_KEY);
      if (app && app.user && app.auth) {
        this.events.publish(EVENTS.APP_USER, null);
        this.authToken = app.auth;
        this.currentUser = app.user;
        this.isLoggedIn = true;
        this.admin = app.admin;
        app.user.admin = app.admin
        return app.user;
      }
    }
  }

  authenticate(data: IAuth, asAdmin: boolean = false): Observable<any> {
    const httpOptions = { headers: new HttpHeaders(asAdmin === true ? { 'x-requested-with': 'admin' } : {}) };
    return this.http.post<any>(this.endpoint, data, httpOptions).pipe(
      map(res => {
        this.events.publish(EVENTS.SESSION_START, res.data);
        this.isLoggedIn = true;
        this.authToken = res.data.auth_token;
        const user = res.data.user;
        this.currentUser = user;
        this.admin = res.data.admin;
        return user;
      })
    );
  }

  postToHubspot(data: any): Observable<any> {
     return this.http.post(
                  `https://api.hsforms.com/submissions/v3/integration/submit/8206300/29d672a4-97f6-478b-a422-46d8bc7a7ca4`,
                  data
                );
  }

  postToHubspotJetLag(data: any): Observable<any> {
     return this.http.post(
                  `https://api.hsforms.com/submissions/v3/integration/submit/ce856dd7-c64c-45b9-9713-fc9d6c3bcc05`,
                  data
                );
  }

  async oAuthLogin(data: { user: any, auth_token: string }): Promise<void> {
    this.events.publish(EVENTS.SESSION_START, data);
    this.isLoggedIn = true;
    this.authToken = data.auth_token;
    this.currentUser = data.user;
  }

  getAuthorizationToken(): string {
    return this.authToken;
  }

  getAuthorizedUser() {
    return this.currentUser;
  }

  validate(): Promise<any> {
    return new Promise(async reject => {
      if (this.isBrowser) {
        const app: any = await this.db.appInstance.getItem(APP_INSTANCE_KEY);
        if (app && app.auth) {
          this.authToken = app.auth;
          this.currentUser = app.user;
          this.isLoggedIn = true;
          this.admin = app.admin;
          this.http.get(this.endpoint).subscribe(
            () => { /* console.log('auth.validation completed, valid authorization') */ },
            err => {
              this.destroy();
              reject(err);
            }
          );
        }
      }
    });
  }

  private destroy() {
    this.isLoggedIn = false;
    (this.authToken as any) = undefined;
    this.currentUser = undefined;
    // this.admin = undefined;
    this.events.publish(EVENTS.SESSION_END, true);
    this.cache.clear();
  }

  signout() {
    this.http.delete(this.endpoint).subscribe();
    this.destroy();
  }

  requestResetPassword(data: { email: string }, asAdmin: boolean = false) {
    const httpOptions = { headers: new HttpHeaders(asAdmin === true ? { 'x-requested-with': 'admin' } : {}) };
    return this.http.post(`${this.endpoint}/reset-password`, data, httpOptions);
  }

  resetPassword(data: { email: string, code: any, password: string }, asAdmin: boolean = false) {
    const httpOptions = { headers: new HttpHeaders(asAdmin === true ? { 'x-requested-with': 'admin' } : {}) };
    return this.http.post(`${this.endpoint}/passwords`, data, httpOptions);
  }

  set domain(domain: string) {
    this._domain = domain;
    this.appDomain.emit(domain);
  }

  get domain() {
    return this._domain;
  }

  get isAdmin(): boolean {
    return this.admin;
  }

}
